
import './App.css';
import React from 'react';
import Weather from './Component/weather';

function App() {
  return (
    <>
    <Weather />
    </>  );
}

export default App;
